"use client";

import { Label as LabelPrimitive } from "radix-ui";
import { cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "cn";

const labelVariants = cva(
  "text-xs block leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-neutral-500 dark:text-neutral-400",
  {
    variants: {
      size: {
        sm: "text-sm font-medium text-neutral-800 dark:text-neutral-200 mb-2",
        large: "text-lg font-semibold text-neutral-800 dark:text-neutral-200 mb-2",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);

const Label = ({
  className,
  size,
  ...props
}: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
  className?: string;
  size?: "sm" | "large";
}) => (
  <LabelPrimitive.Root
    className={cn(labelVariants({ size }), className)}
    {...props}
  />
);

export { Label };
